// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__uNkMo","header":"Messages_header__1uKin"};